import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicantService,SpinnerData } from '../applicant.service'; 
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { environment as ENV } from '../../environments/environment';
import { EncryptionService } from '../encryption.service';

@Component({
  selector: 'wl-customer-consent',
  templateUrl: './customer-consent.component.html',
  styles: [],
  providers: [ApplicantService, ]
})
export class CustomerConsentComponent implements OnInit {

  token = '';
  type = '';
  applicantID = '';
  win: Window;
  verified: boolean;
  progressBar: boolean;
  linkExpired: boolean;
  data: any;

  logo:any;

  sidenavWidth: string = "88";
  sideNavMargin: string = "210";
  selectedMenuItem = '';
 isMenuOpen :boolean = true;
   isMobile = false;
  private breakpointSubscription: Subscription;
  showSpinner: boolean;
  showSpinnerWithMessage: boolean;
  subText: string;
loading :any;

  constructor(private applicant: ApplicantService,
    private route: ActivatedRoute,
    private snackbar: MatSnackBar,
    private router: Router,
    private encryptionService: EncryptionService,
    private breakpointObserver: BreakpointObserver) { 
 // Detect changes in screen size and adjust sidenav mode accordingly
 this.breakpointSubscription = this.breakpointObserver
 .observe([Breakpoints.Small, Breakpoints.XSmall])
 .subscribe((state) => {
   console.log(state)
   this.isMobile = state.matches;
   if(this.isMobile){
     this.sidenavWidth = "98";
     this.isMenuOpen = false;
   }
  

 });


    }

  ngOnInit() {
    console.log('customer-consent---->',this.route.snapshot.queryParamMap);
   // this.token = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe(params => {
      console.log(params);
      this.applicantID = params['id'];
      this.token = params['token'];
       this.type = params['type'];
    });

    this.logo = ENV.logo;
    
    sessionStorage.setItem("applicantId",this.applicantID);

 this.applicant.stringSubject.subscribe((spinnerData: SpinnerData) => {
      console.log(spinnerData)
      this.showSpinner = (spinnerData['showSpinner']);
      this.showSpinnerWithMessage = spinnerData['spinnerWithMessage'];
      this.subText = spinnerData['subText'];
    })

  sessionStorage.setItem("backendPublicKey","MCowBQYDK2VuAyEAgN+Y9OCr1K40SZIUpBJ6/Y0V5yZYgMBT0Fh5ZgMbvxs=");
    this.encryptionService.initiateEncryption();

     sessionStorage.setItem("applicantId",this.applicantID);

    console.log('this.token----->',this.token);
    console.log('this.applicantID----->',this.applicantID);
    this.progressBar = true;
    this.showSpinner = true;
    // this.applicant.submitConsent({token: this.token, applicantId:  this.applicantID}).subscribe((submitResult) => {
    //   this.showSpinner = false;
    //   console.log('submitConsent', submitResult);
    //   if(submitResult) {
    //     if(submitResult.success == true && submitResult.isVerified) {
    //       if(this.type=='business'){
    //         this.data = 'Office Email ID';
    //       }else if(this.type=='personal'){
    //         this.data = 'Personal Email ID';
    //       }else{
          
    //         this.data = 'Mobile Number';
    //        }
    //      const snack = this.snackbar.open("Your data has been recorded. Thank you!", 'OK', { duration: 2000 });
    //       //this.snackbar.dismiss(this.window.close());
    //       // snack.afterDismissed().subscribe(info => {
    //         // this.win.close();
    //         // this.router.navigate(['/consent-thanku'])
    //       // });
    //       this.verified = true;
    //       this.progressBar = false;
    //       this.linkExpired = false;
    //     } else {
    //       this.verified = false;
    //       this.progressBar = false;
    //       this.linkExpired = true;
    //       this.snackbar.open("Link has expired. Please generate again", 'OK', { duration: 2000 });
    //     }
    //   } else {
    //     this.verified = false;
    //     this.progressBar = false;
    //     this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
    //   }
    // },(err) => {
    //   this.showSpinner = false;
    //   this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
    // });

   
    this.applicant.verifyEmailOtp({token: this.token, applicantId:  this.applicantID}).subscribe((submitResult) => {
      this.showSpinner = false;
      console.log('submitConsent', submitResult);
      if(submitResult) {
        if(submitResult.success == true && submitResult.isVerified) {
          if(this.type=='business'){
            this.data = 'Office Email ID';
          }else if(this.type=='personal'){
            this.data = 'Personal Email ID';
          }else{
          
            this.data = 'Mobile Number';
           }
         const snack = this.snackbar.open("Your data has been recorded. Thank you!", 'OK', { duration: 2000 });
          //this.snackbar.dismiss(this.window.close());
          // snack.afterDismissed().subscribe(info => {
            // this.win.close();
            // this.router.navigate(['/consent-thanku'])
          // });
          this.verified = true;
          this.progressBar = false;
          this.linkExpired = false;
        } else {
          this.verified = false;
          this.progressBar = false;
          this.linkExpired = true;
          this.snackbar.open("Link has expired. Please generate again", 'OK', { duration: 2000 });
        }
      } else {
        this.verified = false;
        this.progressBar = false;
        this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
      }
    },(err)=> {
      this.showSpinner = false;
      this.snackbar.open("Verification failed. Please contact the  Admin", 'OK', { duration: 2000 });
    });

  }

  submitConsent() {
   
  }

}
